import { Toast } from '@ui/lib/park/ui/toast';

export const basicToaster = Toast.createToaster({
  placement: 'top-start',
  overlap: false,
  gap: 16,
});
